import Factory from './factory';

module.exports = new Factory();
